'use strict';
import ajax from '../../ajax';
import formPrepare from './formPrepare';
import util from '../../util';
import validator from '../../validator';
import summarysection from '../../pages/summarysection';
import index from '../product/index';
import customModal from '../../modal';
import newAddressForm from '../../addressForm/address-form';
import inputField from '../../addressForm/input-field';
import checkoutAddress from './address';
import account from './../account';
import adyenCheckout from '../../adyen/adyen-checkout';
import checkoutHeader from './checkout-header-accordion';
import reinsuranceCheckout from '../reinsuranceCheckout';
import googleAddressAutocomplete from './googleAddressAutocomplete';
// const cardValidation = require('./card-validation');

var $cache;
var isOOBPaymentInstrumentsConfirmed = false;

$('input[name="brandCode"]').on('change', function () {
  $('#dwfrm_adyPaydata_issuer').val('');
  $('.checkoutComponent').hide();
  $("#component_".concat($(this).val())).show();
});

if($("form").hasClass("checkout-billing")){
  const billingSubmitButton = $('#billing-submit');
	$(".checkout-billing").on("keydown", function(e) {
	    var code = (e.keyCode ? e.keyCode : e.which);
	    if ( (code===13) || (code===10)){//android and ios GO button
	    	e.preventDefault();
			e.stopPropagation();
	    	billingSubmitButton.trigger('click');
	        }
	});
}

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) {
	const selectedPaymentMethod = paymentMethodID;
	
    // ensure checkbox of payment method is checked
    $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
    $('input[name$="_selectedPaymentMethodID"][value=' + selectedPaymentMethod + ']').prop('checked', 'checked');

    if ($('.payment-method-options').length > 0) {
        const $otherPaymentOptions = $(".other-payment-options");
        const $componentContainerSelect = $('.component-container select');

        function handleAdyenPayment() {
            $otherPaymentOptions.removeClass("alternate-selected");
            $('.other-payment-contain').removeClass('showCheckoutComponent');
        }

        function handleOtherPayment() {
            $otherPaymentOptions.addClass("alternate-selected");
            $('.checkoutComponent').hide();
            $('input[id^="is-klarna"]').removeAttr('checked');
            $('input[name="brandCode"]').removeAttr('checked');
            $('#adyenStateData').val('');
        }

        if (selectedPaymentMethod == "AdyenComponent") {
            handleAdyenPayment();
        } else {
            handleOtherPayment();
        }

        // klarna dropdown error handling
        removeAdyenDropdownError();
        $componentContainerSelect.selectmenu({
            classes: {
                "ui-selectmenu-menu": "klarna-select"
            }
        });
    }
}

function removeAdyenDropdownError() {
  const $checkoutComponent = $(".checkoutComponent");
	if($checkoutComponent.find("span.error").length > 0) {
  	$checkoutComponent.removeClass('invalidinput');
  	$checkoutComponent.find("span.error").remove();
	}
}
function initCache() {
	$cache = {};

	$cache.checkoutForm = $(".checkout-billing");
	$cache.selectedCardIdInput = $cache.checkoutForm.find('input[name$="_selectedCardID"]');
}

function openpaybylink() {
	$('input[name="paymentmethods-option"]').on('click',function (e) {
		const $this = $(this);
		if($this.val().toLowerCase() =='paybylink') {
			e.preventDefault();
			e.stopPropagation();
			customModal.createCustomModal('payment-paybylink-popup', '#modal-custom-placeholder');
			const $paymentPaybylinkPopup = $('.payment-paybylink-popup .modal-body');
			$paymentPaybylinkPopup.html(Resources.PAYMENT_PAYBYLINKORDER);
			$paymentPaybylinkPopup.scrollBox();
			$('input[name$="_selectedPaymentMethodID"]').val('paybylink');
			$this.prop('checked', 'checked');
			addOOBPaymentInstrument('PayByLink');
		}
	});
}
function openfreeorder() {
	$('input[name="paymentmethods-option"]').on('click',function (e) {
		const $this = $(this);
		if($this.val().toLowerCase() == 'freeorder'){
			e.preventDefault();
			e.stopPropagation();
			customModal.createCustomModal('payment-paybylink-popup', '#modal-custom-placeholder');
			const $paymentPaybylinkPopup = $('.payment-paybylink-popup .modal-body');
			$paymentPaybylinkPopup.html(Resources.PAYMENT_FREEORDER);
			$paymentPaybylinkPopup.scrollBox();
			$('input[name$="_selectedPaymentMethodID"]').val('freeorder');
			$this.prop('checked', 'checked');
			addOOBPaymentInstrument('FreeOrder');
		}
	});
}
function addOOBPaymentInstrument(orderType) {
	const addOrderOnBehalfPIUrl = Urls.addOrderOnBehalfPI;
	$('#wrapper').on('click', '.confirm-paybylink-order, .confirm-free-order', function () {	
		$.ajax({
			url: addOrderOnBehalfPIUrl,
			data: {
				orderType : orderType
			},
			success: function (response) {
				if(response.success) {
					isOOBPaymentInstrumentsConfirmed = true;
					$('#billing-submit','.billing-continue-container').attr("disabled", false);
					$("#billing-submit").trigger('click');
				}
			}
		});
	});	
}

//address modal close
function addressModalClose() {
	$('#modal-custom-placeholder').on("click", ".edit-add-address .cancel-button", function () {
		$(this).closest('.modal-overlay').remove();
		$('html').removeClass('modal-open');
		$('body').removeClass('body-fixed');
	})
}

/**
* @function
* @description Changes the payment type or issuerId of the selected payment method
* @param {String, Boolean} value of payment type or issuerId and a test value to see which one it is, to which the payment type or issuerId should be changed to
*/
function updatePaymentType(selectedPayType, issuerType) {
	if(issuerType){
	  $('#dwfrm_adyPaydata_issuer').val(selectedPayType);
	}
	else{
	  $('input[name="brandCode"]').removeAttr('checked');
	  $('input[value=' + selectedPayType + ']').prop('checked', 'checked');
	}
	// if the payment type has hidden fields reveal it
	$('#component_' + selectedPayType).show();
	try{
		formPrepare.validateForm();
	} catch (err) {
		console.log(err);
	}
}

function getAddressFromTile() {
	var $selectedAddress = $(".select-billing-address .address-tile.selected address");

	return {
		address1: $selectedAddress.data("address-one"),
		address2: $selectedAddress.data("address-two") || "",
		countryCode: $selectedAddress.data("country-code"),
		stateCode: $selectedAddress.data("state-code"),
		postalCode: $selectedAddress.data("postal-code"),
		city: $selectedAddress.data("city")
	};
}

/*
 * Valid Postal and City
 */

function getValidPostalCity(addressId,displModal,disableBut){
	if(!Constants.IS_OOB_SESSION || (Constants.IS_OOB_SESSION && isOOBPaymentInstrumentsConfirmed)) {
		disableBut == true ? $('#billing-submit').removeAttr('disabled') : '';
	}	
	if(displModal){
		reintAddressModalDef(addressId);
	}
}

/**
 * re-init address modal with error
 */
function reintAddressModalDef(addressID){
	
	$.ajax({
		url: Urls.checkoutEditBillingAddress + encodeURIComponent(addressID),
		dataType: 'html',
		success: function (response) {
			if (response.indexOf('header-wrapper') === -1) {
				customModal.createCustomModal('edit-add-address', '#modal-custom-placeholder');
				$('.edit-add-address').find('.modal-body').html(response);
				util.bodyPositionFixed('edit-add-address');
				$('.ajax-loader').hide();
				addressModalClose();
			}
		}
	}).always(function (data) {
		$('select').selectmenu();
		checkoutAddress.init();
		validator.initStateValidation();
		validator.initCountryChangeValidation();
		validator.initForm('form[id="EditAddressForm"]');
		const setDefaultCheckbox = $('input[id$="_setdefault"]');
		newAddressForm.init();
		//prepopulate both Phone fields while editting
		newAddressForm.populatePhoneFields($('input[id$="_phone"]').val());
		if (setDefaultCheckbox.prop('checked')) {
			setDefaultCheckbox.attr('disabled', 'true');
		}
		$('.edit-add-address .modal-body').scrollBox();
		//Hide addressname on billing
		if ($('.pt_checkout').length > 0 && $('.addressname').length > 0) {
			$('.edit-add-address').find('.addressname').addClass('hidden');
		}
	});
}

// Checkout Newsletter Optin Consent

function setProfilingConsentEnabled($profilingConsentPref, enabled) {
        const $statusRegion = $('[data-profiling-consent-status]');
        const wasEnabled = $profilingConsentPref.attr('aria-disabled') === 'false';
		const profilingConsentHintId = $('.profiling-consent-hint').attr('id');

        if (enabled === wasEnabled) {
            return;
        }

        $profilingConsentPref.attr('aria-disabled', enabled ? 'false' : 'true');
        if (enabled) {
            $profilingConsentPref.removeAttr('aria-describedby');
        } else {
            $profilingConsentPref.prop('checked', false);
            $profilingConsentPref.attr('aria-describedby', profilingConsentHintId);
        }

        if ($statusRegion.length) {
            $statusRegion.text(enabled
                ? $statusRegion.data('enabledText')
                : $statusRegion.data('disabledText'));
        }
}

const initializeOptinContainer = () => {
	const $paymentConsentPref = $('.checkout-newsletter-optional input[type="checkbox"]');

	setProfilingConsentEnabled($paymentConsentPref, false);

	if ($('.checkout-main-wrapper .hide-btn-container').length) {
		$('.checkout-main-wrapper .show-content-wrapper').remove();
	}

	// Prevent interaction when aria-disabled=true
	$('.checkout-newsletter-optional').on( 'click keydown', 'input[type="checkbox"]', (e) => {
			const $checkbox = $(e.currentTarget);
			const isDisabled = $checkbox.attr('aria-disabled') === 'true';
			const isBlockedKey = [' ', 'Spacebar'].includes(e.key);

			isTermsChecked();

			if (isDisabled && (e.type === 'click' || isBlockedKey)) {
				e.preventDefault();
			}
		}
	);

	// Checkbox toggle
	$('.pt_checkout .order-summary-footer').on( 'click keydown', '.checkout-newsletter-optin input[type="checkbox"]', function (e) {
			const $checkbox = $(this);
			const isChecked = $checkbox.prop('checked');
			const isMobile = window.innerWidth < 480;
			const isDesktop = !isMobile;

			const $parentContainer = $checkbox.closest('.checkout-newsletter-optin');
			const $showContentWrapper = $parentContainer.find('.show-content-wrapper');
			const hasShowContent = $showContentWrapper.length > 0;

			const $secondaryText = $parentContainer.find('.secondary-text');
			const $primaryText = $parentContainer.find('.primary-text');
			const $seeMore = $parentContainer.find('.see-more-consent');
			const $seeLess = $parentContainer.find('.see-less-consent');

			isTermsChecked();

			setProfilingConsentEnabled($paymentConsentPref, isChecked);

			setTimeout(() => {
				if(!$('input[id$="_userconsent_termsandconditions"]').is(':checked')) {
					$('#billing-submit').prop('disabled', false);
				}
			}, 50);

			if (isDesktop) {
				$seeMore.removeClass('is-active');
				$seeLess.removeClass('is-active');
				$secondaryText.toggleClass('is-active', isChecked);
				return;
			}

			// Mobile without "Show More"
			if (!hasShowContent) {
				$secondaryText.toggleClass('is-active', isChecked);
				return;
			}

			// Mobile with "Show More"
			if (isChecked) {
				$primaryText.addClass('show-text');
				$seeMore.addClass('is-active');
			} else {
				$primaryText.removeClass('show-text');
				$seeMore.removeClass('is-active');

				if (!$seeMore.hasClass('is-active')) {
					$secondaryText.removeClass('is-active');
					$seeLess.removeClass('is-active');
				}
			}
		}
	);

	function isTermsChecked() {
		const $termsAndConditions = $('input[id$="_userconsent_termsandconditions"]');
		setTimeout(() => {
			if ($termsAndConditions.is(':checked')) {
				$('#billing-submit').prop('disabled', false);
			}
		}, 0);
	}
	
	// Show more content
	$('.checkout-newsletter-optin').on('click', '.see-more-consent', function () {
		const $parentContainer = $(this).closest('.checkout-newsletter-optin');

		$(this).removeClass('is-active');
		$parentContainer.find('.secondary-text').addClass('is-active');
		$parentContainer.find('.see-less-consent').addClass('is-active');
	});

	// Show less content
	$('.checkout-newsletter-optin').on('click', '.see-less-consent', function () {
		const $parentContainer = $(this).closest('.checkout-newsletter-optin');

		$(this).removeClass('is-active');
		$parentContainer.find('.secondary-text').removeClass('is-active');
		$parentContainer.find('.see-more-consent').addClass('is-active');
	});
};

function consentErrorHandling() {
	$('.order-summary-footer').on('change keydown', 'input[id$="_userconsent_termsandconditions"]', function() {
        const $termsErrorMsg = $(".checkout-step.billing .billing-address-section .consent-check-error");
        if($(this).is(':checked')) {
			$termsErrorMsg.find('span.error').remove();
            $termsErrorMsg.hide();
			const btnDisableCheck = util.debounce(() => {
				$('#billing-submit').removeAttr('disabled');
			}, 100);
			btnDisableCheck();
        }  else {
            $termsErrorMsg.show();
        }
    });
}
function clearConsentError() {
	let isTimer = null; 
	const $consentError = $(".checkout-step.billing .billing-address-section .consent-check-error");
	const $termsandconditions = $(".checkout-step.billing .order-summary-footer .user-consent-container .termsandconditions");
	if(isTimer) {
		clearTimeout(isTimer);
	}
	if($consentError.find('span.error').is(":visible")) {
		$consentError.remove();
		$termsandconditions.prop('checked', false);
		$termsandconditions.removeClass("error");
	}
}

var populatePhoneFieldsBilling = function (phone) {
	/*
		This code is replica of address-form.js populatePhoneFields function, Due function don't have 
		dynamic selector this is only effect first selector caught in DOM, And we have a two form in the 
		shipping page where phone filed populated with first shipping form instead of billing form. This
		code need to optimize with dynamic selector in the address-form.js and will be removed from here later on.
	*/
    var selectedCountryCode = $('.select-billing-address select[id$="_country"]').data('country');
    if (selectedCountryCode) {
        var areaCode = util.getCallingCountryCode(selectedCountryCode.toLowerCase());
        if (areaCode && phone) {
            var phonenumber = phone.replace(new RegExp("^(\\"+ areaCode +")[\\s-]*(\\d{6,18})$"), "$2");
            $('.select-billing-address input[id$="_areaCode"]').val(areaCode);
            $('.select-billing-address input[id$="_phoneNumber"]').val(phonenumber);
        }
        $('.select-billing-address select[id$="_country"]').val(selectedCountryCode).trigger('change');
    }    
}

function sameAsShipping () {
	var sameasBilling = 'input.sameasbilling';
	$(sameasBilling).on('change', function () {
		savedAddressViewBilling();
		var sameascheckbox = $(this);

		if (sameascheckbox.is(":checked")) {
			$('.saved-addresses.select-billing-address').addClass('hidden');
			$('.saved-addresses.default-billing-address').removeClass('hidden');

			$('#dwfrm_billing_billingAddress_addressFields_firstName').val($('#dwfrm_billing_billingAddress_addressFields_firstName').attr('data-firstname'));
			$('#dwfrm_billing_billingAddress_addressFields_lastName').val($('#dwfrm_billing_billingAddress_addressFields_lastName').attr('data-lastname'));
			if ($('#dwfrm_billing_billingAddress_addressFields_lastName2').length > 0) {
				$('#dwfrm_billing_billingAddress_addressFields_lastName2').val($('#dwfrm_billing_billingAddress_addressFields_lastName2').attr('data-lastname2'));
			}
			$('#dwfrm_billing_billingAddress_addressFields_address1').val($('#dwfrm_billing_billingAddress_addressFields_address1').attr('data-address1'));
			$('#dwfrm_billing_billingAddress_addressFields_address2').val($('#dwfrm_billing_billingAddress_addressFields_address2').attr('data-address2'));
			$('#dwfrm_billing_billingAddress_addressFields_city').val($('#dwfrm_billing_billingAddress_addressFields_city').attr('data-city'));
			$('#dwfrm_billing_billingAddress_addressFields_city').val($('#dwfrm_billing_billingAddress_addressFields_city').attr('data-city'));
			$('#dwfrm_billing_billingAddress_addressFields_postal').val($('#dwfrm_billing_billingAddress_addressFields_postal').attr('data-postal'));
			$('#dwfrm_billing_billingAddress_addressFields_country').val($('#dwfrm_billing_billingAddress_addressFields_country').attr('data-country'));
			$('#dwfrm_billing_billingAddress_addressFields_states_state').val($('#dwfrm_billing_billingAddress_addressFields_states_state').attr('data-state'));
			$('#dwfrm_billing_billingAddress_addressFields_phoneNumber').val($('#dwfrm_billing_billingAddress_addressFields_phone').attr('data-phone'));
			populatePhoneFieldsBilling($('.select-billing-address input[id$="_phone"]').val());
			$('#sameAsShippingAddress').val(true);

			// for logged-in users with address, reselect default shipping address
			// if customer chooses to use the shipping address as their billing address
			var selectedShipping = $('.select-billing-address div.address-tile.address-default');
			if (selectedShipping) {
				selectedShipping.removeClass('default');
				selectedShipping.click();
			}

			// Check address block empty or not
			if($(".address-name-block .address-name").length){
				if($(".address-name-block .address-name").html().trim().length == 0) {
					$('.selected-billing-address').hide();
				}
			}
		} else {
			$('.saved-addresses.default-billing-address').addClass('hidden');
			$('.saved-addresses.select-billing-address').removeClass('hidden');
			$('.billing-address-section').find('.addressname').addClass('hidden');
			populatePhoneFieldsBilling($('.select-billing-address input[id$="_phone"]').val());
			$('#dwfrm_billing_billingAddress_addressFields_firstName').val('');
			$('#dwfrm_billing_billingAddress_addressFields_lastName').val('');
			if ($('#dwfrm_billing_billingAddress_addressFields_lastName2').length > 0) {
				$('#dwfrm_billing_billingAddress_addressFields_lastName2').val('');
			}	
			$('#dwfrm_billing_billingAddress_addressFields_address1').val('');
			$('#dwfrm_billing_billingAddress_addressFields_address2').val('');
			$('#dwfrm_billing_billingAddress_addressFields_city').val('');
			$('#dwfrm_billing_billingAddress_addressFields_postal').val('');
			$('#dwfrm_billing_billingAddress_addressFields_phone').val('');
			$('#dwfrm_billing_billingAddress_addressFields_phoneNumber').val('');
			$('#dwfrm_billing_billingAddress_addressFields_postcode').val('');
			$('#dwfrm_billing_billingAddress_addressFields_province').val('');
			$('#dwfrm_billing_billingAddress_addressFields_states_state').val('');
			$('#dwfrm_billing_billingAddress_addressFields_states_state').selectmenu('refresh');
			$('#sameAsShippingAddress').val(false);
			$('.select-billing-address').find('.set-default-cb').addClass('hidden');

			// Remove focus on input when their are no error
			if(!$('.select-billing-address .error-placement')==false) {
				$('.select-billing-address .material-input').removeClass('focus-in');
				$('.select-billing-address .material-input .phonenumber').removeClass('error');
			}
			$( ".billing-address-section").find(".billing-address-header-new" ).after( $( ".placecountry-billing" ) );
			var countryMenu = $('#dwfrm_billing_billingAddress_addressFields_country-menu li');
			var countryVal = $('.saved-addresses.select-billing-address').closest('form').find('.input-select.country').val();

			if (countryVal == 'GB') {
				$(countryMenu).find('.flag-gb').parent().trigger('click');
			} else if (countryVal == 'AT') {
				$(countryMenu).find('.flag-at').parent().trigger('click');
			} else if (countryVal == 'ES') {
				$(countryMenu).find('.flag-es').parent().trigger('click');
			} else if (countryVal == 'BE') {
				$(countryMenu).find('.flag-be').parent().trigger('click');
			} else if (countryVal == 'IT') {
				$(countryMenu).find('.flag-it').parent().trigger('click');
			} else if (countryVal == 'FR') {
				$(countryMenu).find('.flag-fr').parent().trigger('click');
			} else if (countryVal == 'DE') {
				$(countryMenu).find('.flag-de').parent().trigger('click');
			}
		}
	});
}

//View More Functionality for saved billing address section of redesign
function savedAddressViewBilling () {
	var savedAddressBilling = $('.saved-addresses.select-billing-address .address-tile');
	var seeMore = $('.billing-address-show-more');

	if (savedAddressBilling.length > 3) {
		if($('.checkout-step').find('.billing-address-show-more').length == 0 ) {
			$('.billing-address-section').after("<div class='billing-address-show-more'>" + Resources.SEE_MORE_CARDS + "</div>");
		}

		$(seeMore).on('click', function () {
			if ($(seeMore).text() !== Resources.SEE_LESS_CARDS) {
				$(seeMore).text(Resources.SEE_LESS_CARDS);
				$(seeMore).addClass('is-show');
			} else {
				$(seeMore).text(Resources.SEE_MORE_CARDS);
				$(seeMore).removeClass('is-show');
			}

			savedAddressBilling.toggle();
		});
	}

	if ($('input.sameasbilling').is(":checked")) {
		$('.billing-address-show-more').hide();
	} else if ((!$('input.sameasbilling').is(':checked')) && savedAddressBilling.length > 3) {
		$('.billing-address-show-more').show();
	}
}

function sameAsShippingUpdate () {
	var sameasBilling ='input.sameasbilling';
	//update the checkobox with backend value
	if ( ($(sameasBilling).length > 0  &&  $('#sameAsShippingAddress').val() == null) || ($(".checkout_page").length && !$(sameasBilling).is(":checked"))) {
		$(sameasBilling).trigger('change');
	}
	// if same as shipping is checked, re-select default address
	// or if nothing is selected, re-select default address
	if (($(sameasBilling).length > 0 && $(sameasBilling).is(":checked") &&  $('#sameAsShippingAddress').val() == null) ||
		$('.select-billing-address div.address-list div.address-tile.selected').length <= 0) {
				
		$('#wrapper').find('.select-billing-address div.address-list div.address-tile').each(function (ind, evt) {
			if ($(this).hasClass('default') || $(this).hasClass('selected') || $(this).hasClass('address-default')) {
				$(this).removeClass('selected');
				$(this).removeClass('default');

				$(this).trigger('click');
			}
		});
	} else if ($(sameasBilling).length == 0 && $('div.address-list div.address-tile.selected').length > 0) {
		// if no physical product to ship, re-select tile to properly assign billing address
		var reSelectTile = $('.select-billing-address div.address-list div.address-tile.selected');
		reSelectTile.removeClass('selected');
		reSelectTile.removeClass('default');
		reSelectTile.trigger('click');
	}
}

function billingAddressFunctions () {
	$('.saved-addresses.select-billing-address').on('click', '.address-list .address-tile', function (evt) {
		if ($(this).is('.selected, .default') || evt.target.nodeName == 'A') {
			return false;
		} else {
			$('.saved-addresses.select-billing-address').find('.address-list .address-tile').each(function () {
				$(this).removeClass('selected');
				$(this).removeClass('default');
			});

			$(this).addClass('selected');

			var element = document.getElementById(evt.currentTarget.id);
			var addressID = element.dataset.addressId;

			var sameasBilling = 'input.sameasbilling';
			var url = util.appendParamsToUrl(Urls.updateBillingAddressDetails, {
				addressID: addressID, isSameAsShipping : $(sameasBilling).is(':checked'),
			});
			$.ajax({
				url: url,
				type: 'GET',
				success: function (result) {getValidPostalCity(addressID,false,true);	}
			});
			clearConsentError();
			consentErrorHandling();
		}
	});
}

//Form Submission of New Address Creation Modal
function addressCreateFromModal () {
	$('#EditAddressForm').on('click', '.add-edit-address-cta', function (e) {	
		e.preventDefault();
		e.stopPropagation();
		const formAction = $('#EditAddressForm').attr('action');
		const $form = $('form#EditAddressForm');
		const postData = $form.serialize() + "&dwfrm_profile_address_create=dwfrm_profile_address_create=" + $( "body" ).hasClass( "checkout_page" );
		$.ajax({
			type: 'POST',
			url: formAction,
			data: postData,
			success: function (response) {
				if(response.success){
					location.reload();
				}
			}
		});
	});
}

//Form submission of edit address Modal
function addressSubmissionFromModal (addressid) {
	$('#EditAddressForm').on('click', '.add-edit-address-cta', function (e) {	
		e.preventDefault();
		e.stopPropagation();
		const formAction = $('#EditAddressForm').attr('action');
		const $form = $('form#EditAddressForm');
		const postData = $form.serialize() + "&dwfrm_profile_address_edit=dwfrm_profile_address_edit&addressid=" + addressid;
		$.ajax({
			type: 'POST',
			url: formAction,
			data: postData,
			success: function (response) {
				if(response.success){
					location.reload();
				}
			}
		});
	});
}

function editBillingAddress() {
	$('.saved-addresses.select-billing-address')
		.on("click", ".address-create", function(evt) {
			evt.stopImmediatePropagation();
		$('.ajax-loader').show();
		$.ajax({
			url: Urls.checkoutAddBillingAddress,
			dataType: 'html',
			success: function (response) {
				if (response.indexOf('header-wrapper') === -1) {
					customModal.createCustomModal('edit-add-address new-add-address', '#modal-custom-placeholder');
					$('.edit-add-address').find('.modal-body').html(response);
					util.bodyPositionFixed('edit-add-address');
					!$('.edit-add-address .focus-in .phonenumber').val() && $('.edit-add-address .phonenumber').closest('.focus-in').removeClass('focus-in');
					$('.ajax-loader').hide();
					addressModalClose();
				}
				$( ".editaddress").find(".redesign-hidden" ).after( $( ".placecountry-edit-billing" ) );
			}
		}).always(function (data) {
			checkoutAddress.init();
			$('select').selectmenu();
			validator.initStateValidation();
			validator.initCountryChangeValidation();
			validator.initForm('form[id="EditAddressForm"]');
			$('.edit-add-address .modal-body').scrollBox();
			newAddressForm.init();
			googleAddressAutocomplete.init();
			//Hide addressname on billing
			if ($('.pt_checkout').length > 0 && $('.addressname').length > 0) {
				$('.edit-add-address').find('.addressname').addClass('hidden');
			}
		});			   

		const createBillingAddressCall = util.debounce(() => {
			util.limitCharacters();
			$('.addressname .addressid').attr('type', 'hidden'); // Avoid to autocomplete address 1
			addressCreateFromModal();
			validator.changeFieldValidation();
		}, 2500);
		createBillingAddressCall();

	})
	// edit address link
	.on("click", ".address-edit", function (evt) {

		const $this = $(this);
		const addressID = $this.data('addressId');
		$('.ajax-loader').show();
		$.ajax({
			url: Urls.checkoutEditBillingAddress + encodeURIComponent(addressID),
			dataType: 'html',
			success: function (response) {
				getValidPostalCity(addressID,true,false);
			}
		}).always(function () {				
			inputField.setEditMaterialFields('.checkout-shipping .material-input .input-text');
		});		
		const editBillingAddressCall = util.debounce(() => {
			util.limitCharacters();
			$('.addressname .addressid').attr('type', 'hidden'); // Avoid to autocomplete address 1
			googleAddressAutocomplete.init();
			addressSubmissionFromModal(addressID);
			$( ".editaddress").find(".redesign-hidden" ).after( $( ".placecountry-edit-billing" ) );
			validator.changeFieldValidation();
		}, 2000);
		editBillingAddressCall();
	});
}

function toggleBillingAddressFields(visible) {
	if (visible == true) {
		$('.country-dependent').each(function () {
			$(this).show();
		});
	} else {
		$('.country-dependent').each(function () {
			$(this).hide();
		});
	}

	if (window.User.isCustomerAuthenticated == false) {
		$('.checkout-billing').find('.set-default-cb').hide();
	}
}

function BillingAddressFieldsToggle() {
	$('#modal-custom-placeholder').on('change', '#dwfrm_billing_billingAddress_addressFields_country, #dwfrm_billingaddress_country', function () {
		const selectContry = $(this).val();
		if (selectContry == '') {
			toggleBillingAddressFields();
		} else if (selectContry == 'us') {
			toggleBillingAddressFields(true);
			$('.us-fields').show();
			$('.us-fields input').each(function () {
				$(this).addClass('required');
			});

			$('.cn-fields').hide();
			$('.cn-fields input').each(function () {
				$(this).removeClass('required');
			});
		} else {
			toggleBillingAddressFields(true);
			$(".cn-fields").show().css({
				"display": "flex"
			});
			$('.cn-fields input').each(function () {
				$(this).addClass('required');
			});

			$('.us-fields').hide();
			$('.us-fields input').each(function () {
				$(this).removeClass('required');
			});
		}
	});

	$('.billing-address-section :input').on('change', function (e) {
		if (e.target.id == 'dwfrm_billing_billingAddress_useAsBillingAddress') {
			return false;
		}

		$('#dwfrm_billing_billingAddress_useAsBillingAddress').prop('checked', false);
	});
}

function handleCreditCardFields() {
	$('.other-payment-options').on('click',function (){
		$('#newCard').hide();
	});
	$('.credit-card-icons-container').on('click',function(){
		$('#newCard').show();
		$('.other-payment-contain .additionalFields').hide();  
	});
}


/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */

export const singleShippingDesign = function () {
	newAddressForm.init();
	sameAsShipping();
	sameAsShippingUpdate();
	billingAddressFunctions();
	reinsuranceCheckout.reinsuranceCartOnLoad();
	editBillingAddress();
	BillingAddressFieldsToggle();
	getAddressFromTile();
	savedAddressViewBilling();
	util.getPhoneNumWithCode();
}

export default {
	init : function () {
		//cardValidation.init();
		if (Constants.IS_OOB_SESSION) {
			openfreeorder();
			openpaybylink();
			const $billingSubmit = $('#billing-submit');
			$billingSubmit.attr("disabled", true);
			$billingSubmit.on('click', function () {
				if (!isOOBPaymentInstrumentsConfirmed) {
					event.preventDefault();
					return false;
				}
			});

			$('#wrapper').on('click', '.modal-close, .modal-close-outer, .modal-close-btn', function () {
				if (!isOOBPaymentInstrumentsConfirmed) {
					$('#billing-submit', '.billing-continue-container').attr("disabled", true);
				}
			});
		}
		initCache();
		summarysection.init();
		validator.initCountryChangeValidation();
		editBillingAddress();

		var $selectPaymentMethod = $('.payment-method-options');
		var selectedPaymentMethod = $selectPaymentMethod.find('input[name$="_selectedPaymentMethodID"]:checked').val();
		$cache.$payType = $('[name="brandCode"]');
		var $issuer = $('.issuer');
		var selectedPayType = $cache.$payType.find(':checked').val();
		validator.initStateValidation();
		validator.initForm('form[id$="billing"]');

		toggleBillingAddressFields();

		BillingAddressFieldsToggle();

		sameAsShipping();

		if ($(".applepay-container-wrapper").length) {
			$('.applepay-container-wrapper, .applepay-container-wrapper button').hide();
		}

		// default payment method to 'CREDIT_CARD'
		updatePaymentMethod('AdyenComponent');

		$selectPaymentMethod.on('click', 'input[name$="_selectedPaymentMethodID"]', function () {
			updatePaymentMethod($(this).val());
			if ($(this).val() == 'Adyen' && $cache.$payType.length > 0) {
				// set payment type of Adyen to the first one
				updatePaymentType((selectedPayType) ? selectedPayType : $cache.$payType[0].value, false);
			} else {
				//$cache.$payType.removeAttr('checked');
			}
		});

		$cache.$payType.on('click', function () {
			updatePaymentType($(this).val(), false);
			$('input[value="AdyenComponent"]').prop('checked', 'checked').trigger('click');

			if (Constants.KLARNA_GRP_METHOD.indexOf($(this).val()) > -1) {
				$('.klarna-component').on('selectmenuchange change', function () {
					$('input[id^="is-klarna"]').val($(this).val());
				});
			}
		});

		$issuer.on('change', function () {
			updatePaymentType($(this).val(), true);
		});

		$('.addressname .addressid').attr('type', 'hidden'); // Avoid to autocomplete address 1

		$(document).ready(function () {
			billingAddressFunctions();
			sameAsShippingUpdate();
		});

		$('.order-summary-footer form').submit(function () {
			$('#summary-place-order, #sticky-place-order').prop('disabled', true).addClass('loading');
			return true;
		});

		// trigger click event for selected by default cc (to manually trigger cc code)
		var selectedCC = $('div.payment-method div.creditcard-tile.selected');
		if (selectedCC) {
			selectedCC.removeClass('selected').click();
		}

		// maximize order checkout summary dropdown
		util.maximizeCheckoutSummary();

		// Review step Screen offset
		if (window.innerWidth <= 768) {
			var reviewButton = $('.primary-content .review').find('#summary-place-order');
			if (reviewButton.length > 0) {
				var element = $('.primary-content .review');
				var offset = element.offset();
				var offsetTop = offset.top;
				$('html, body').scrollTop(offsetTop - 200);
			}
		}

		$cache.$payType.on('change', function () {
			$('#selectedIssuer').val("");
			$issuer.hide();
			$('.checkoutComponent').hide();
			$('#component_' + $(this).val()).show();

			if ($(this).siblings(".issuer").length > 0) {
				$('#selectedIssuer').val($(this).siblings(".issuer").val());
				$(this).siblings('.issuer').show();
			}
			if (Constants.KLARNA_GRP_METHOD.indexOf($(this).val()) > -1) {
				$('.klarna-component-wrapper').show();
			}
			else {
				$('.klarna-component-wrapper').hide();
			}
			var $otherPaymentCont = $('.other-payment-contain');
			if ($('.checkoutComponent').length > 0) {
				$('.ajax-loader').hide();
				$otherPaymentCont.addClass('showCheckoutComponent');
				$(".other-payment-options").addClass("alternate-selected");
			} else {
				$otherPaymentCont.removeClass('showCheckoutComponent');
				$(".other-payment-options").removeClass("alternate-selected");
			}
		});

		$(window).on('load', function () {
			if ($('#apple-pay-wrapper').find('button.dw-apple-pay-button').length !== 0) {
				$('#apple-pay-wrapper').css('display', 'block');
			}

			checkoutAddress.init();
			$cache.$payType = $('[name="brandCode"]').length > 0 ? $('[name="brandCode"]') : console.log('brand code not found');
		});

		if (SitePreferences.ADYEN_SF_ENABLED) {
			adyenCheckout.initBilling();
		}

		$cache.$payType = $('[name="brandCode"]').length > 0 ? $('[name="brandCode"]') : console.log('brand code not found');

		initializeOptinContainer();
		clearConsentError();
		consentErrorHandling();
		$('#secondary .product-item-container.sb-container').scrollBox();
		savedAddressViewBilling();
		handleCreditCardFields();
		checkoutHeader.init();
		//place country field to the top in billing address section
		$(".billing-address-section").find(".billing-address-header-new").after($(".placecountry-billing"));
		reinsuranceCheckout.reinsuranceCartClickEvent();
		util.getPhoneNumWithCode();
		reinsuranceCheckout.reinsuranceCartOnLoad();
	},
	singleShippingDesign
}